class HasClass {
    constructor(selector) {
        this.$ = $(selector);
    }

    has(className, cb) {
        if (this.$.hasClass(className)) {
            cb();
        }
    }

    hasClasses(selectors, cb) {
        for (var i in selectors) {
            if (this.$.hasClass(selectors[i])) {
                cb();
            }
        }
    }
}

module.exports = HasClass;